const lbaHotelTagSelect = angular.module('app.lbaHotelTagSelect', []);

lbaHotelTagSelect.controller('lbaHotelTagSelectCtrl', require('./lbaHotelTagSelectCtrl'));
lbaHotelTagSelect.directive('lbaHotelTagSelect', require('./lbaHotelTagSelectDir'));
lbaHotelTagSelect.service('hotelTagService', require('../../services/hotelTagService'));

export default lbaHotelTagSelect;



// WEBPACK FOOTER //
// ./src/components/lbaHotelTagSelect/index.js